import { useContext } from 'react';
import { GetStartedContext } from 'context/GetStartedContext';

const useGetStartedContext = () => {
  return { ...useContext(GetStartedContext) };
};

export default useGetStartedContext;
